import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Typography,
} from '@mui/material';

enum ConnectErrors {
  NoPlan = 'no_paid_plan',
}

export const ErrorMessages: Record<ConnectErrors, string> = {
  [ConnectErrors.NoPlan]: 'This integration only supports paid DocuSign plans.',
};

const ErrorTitles: Record<ConnectErrors, string> = {
  [ConnectErrors.NoPlan]: 'DocuSign plan not supported',
};

interface Props extends DialogProps {
  errorMessage?: string;
  onClose: () => void;
}

const IntegrationErrorDialog: React.FC<Props> = (props: Props) => {
  const { errorMessage, open, onClose, ...dialogProps } = props;

  const errorString = () => {
    if (!errorMessage) {
      return 'The connection was not completed';
    }

    if (errorMessage in ErrorMessages) {
      return ErrorMessages[errorMessage as ConnectErrors];
    }

    return errorMessage;
  };

  const errorTitle = () => {
    if (!errorMessage) {
      return 'Incomplete integration';
    }
    if (errorMessage in ErrorMessages) {
      return ErrorTitles[errorMessage as ConnectErrors];
    }
  };

  const renderContent = () => (
    <>
      <Typography paragraph variant="body2">
        {errorString()}
      </Typography>
    </>
  );

  return (
    <Dialog open={open} fullWidth maxWidth="xs" {...dialogProps}>
      <DialogTitle>{errorTitle()}</DialogTitle>
      <DialogContent>{renderContent()}</DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onClose} variant="contained">
          Got It
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IntegrationErrorDialog;
